export default {
  en: {
    Type: "Type",
    Description: "Description",
  },
  es : {
    Type: "Tipo",
    Description: "Descripción",
  },
  ca : {
    Type: "Tipus",
    Description: "Descripció",
  }
};
